import type { ProductTag } from "@s2z-platform/constants";

export class TransactionOrderDetailJSON {
  productType: ProductTag;
  quantity: number;
  // impactProduct?: any; // ImpactProductEntity;
}
